import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import {
  getAllCleanerShifts,
  getuserinformation,
  savereminderdata,
  savetasksdata,
  savevehicledata,
  updateItem,
} from "../../utils/firebasefunctions";
import { FaUser } from "react-icons/fa";
import userlogo from "../images/user.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { RotatingLines } from "react-loader-spinner";
import { IoIosCloseCircle } from "react-icons/io";
import { actionType } from "../context/reducer";
import { ToastContainer, toast } from "react-toastify";
import { FaCircleMinus } from "react-icons/fa6";
import carlogo from "../images/car.png";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { FaCar } from "react-icons/fa";
import {
  arrayUnion,
  collection,
  doc,
  onSnapshot,
  query,
} from "firebase/firestore";
import { firestored, storage } from "../../firebase.config";

import { useStateValue } from "../context/StateProvider";
import EmployeePopup from "./EmployeePopup";
import ProjectPopUp from "./ProjectPopUp";

const containerStyle = {
  width: "100%",
  minHeight: "100%",
};

const Taskpopup = (props) => {
  const [{ user, employees, clients }, dispatch] = useStateValue();
  const [employeedata, setemployeedata] = useState();
  const [employeepopup, setemployeepopup] = useState(false);
  const [projectpopup, setprojectpopup] = useState(false);
  const [remindertime, setremindertime] = useState("12:00");
  const [selectedemployee, setselectedemployee] = useState([]);
  const [selectedproject, setselectedproject] = useState("");
  const [selectedtasktype, setselectedtasktype] = useState("One Time");
  const [taskloader, settaskloader] = useState(false);
  const [loader, setloader] = useState(false);

  const [newtask, setnewtask] = useState("");
  const [selecteddate, setselecteddate] = useState(new Date());
  const [tasktypes, settasktypes] = useState([
    {
      type: "One Time",
    },

    {
      type: "Daily",
    },
    {
      type: "Weekly",
    },
    {
      type: "Monthly",
    },
    {
      type: "Yearly",
    },
  ]);
  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        setremindertime("12:00");
        setnewtask("");
        setselecteddate(new Date());
        setselectedemployee([]);
        setselectedproject("");
        let employeesdata = [...employees];
        for (const key in employeesdata) {
          employeesdata[key].selected = false;
        }

        dispatch({
          type: actionType.STORE_EMPLOYEES,
          payload: employeesdata,
        });
        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  const convertToTimestamp = (date, timeString) => {
    // Split the time string into hours and minutes
    const [hours, minutes] = timeString.split(":").map(Number);

    // Create a new Date object for the current day
    const now = new Date(date);

    // Set the hours and minutes based on the time string
    now.setHours(hours, minutes, 0, 0); // Set hours, minutes, seconds, milliseconds to 0

    // Return the Unix timestamp (milliseconds since January 1, 1970)
    return now.getTime();
  };
  async function setupreminder() {
    if (newtask.trim() == "") {
      toast.warn("Please enter a task note!");
    } else if (remindertime == undefined || remindertime == "") {
      toast.warn("Please select a task time!");
    } else if (selectedemployee.length == 0) {
      toast.warn("Please select atleast 1 Supervisor to assign a task to!");
    } else {
      setloader(true);

      console.log(JSON.stringify(selectedemployee));

      let employeeid = [];

      for (const key in selectedemployee) {
        employeeid.push(selectedemployee[key].id);
      }

      const res = await fetch(
        // "https://us-central1-raftekpro-82bb0.cloudfunctions.net/scheduleOneTimeJob",
        "https://us-central1-raftekpro-82bb0.cloudfunctions.net/api/todolisttasknotify",

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            remindernote: newtask.trim(),
            employeelist: employeeid,
            deadlinetimestamp: moment(
              convertToTimestamp(selecteddate, remindertime),
            ).format("YYYY-MM-DD hh:mm:ss a"),
            adminid: user.usertype == "Supervisor" ? user.createdby : user.id,
            type: selectedtasktype,
          }),
        },
      );

      if (res.status == 200) {
        let now = new Date();
        let nextRun = new Date(now);

        switch (selectedtasktype) {
          case "Daily":
            nextRun.setDate(now.getDate() + 1);
            const day = nextRun.getDay();
            if (day === 6) {
              // If Saturday → move to Monday
              nextRun.setDate(nextRun.getDate() + 2);
            } else if (day === 0) {
              // If Sunday → move to Monday
              nextRun.setDate(nextRun.getDate() + 1);
            }
            break;
          case "Weekly":
            nextRun.setDate(now.getDate() + 7);
            break;
          case "Monthly":
            nextRun.setMonth(now.getMonth() + 1);
            break;
          case "Yearly":
            nextRun.setFullYear(now.getFullYear() + 1);
            break;
          default:
            nextRun = now; // one-time
        }

        // const task = {
        //   title,
        //   description,
        //   type,
        //   userId,
        //   createdAt: now.toISOString(),
        //   nextRun: nextRun.toISOString(),
        //   completed: false,
        //   lastRun: null
        // };

        console.log("Notififcation " + JSON.stringify(res));
        const dataresponse = await res.json();
        console.log(dataresponse);
        console.log("Successfully Notified User");
        let creationtime = Date.now();
        let data = {
          id: creationtime,
          taskfamilyid: creationtime,
          creationdate: creationtime,
          task: newtask.trim(),
          employeelist: employeeid,
          dealinetime: remindertime,
          deadlinedate: moment(selecteddate).format("YYYY-MM-DD"),
          deadlinetimestamp: convertToTimestamp(selecteddate, remindertime),
          createdby: user.id,
          Status: "Pending",
          type: selectedtasktype,
          nextRun: selectedtasktype == "One Time" ? null : nextRun.getTime(),
          nextruncompleted: selectedtasktype == "One Time" ? true : false,
          // schecduledtaskname: dataresponse.remindername,
          projectid: selectedproject.id,
        };

        await savetasksdata(data, data.id)
          .then((response) => {
            if (response == "success") {
              toast.success("Supervisor Task Created Successfully");
              setremindertime("12:00");
              setnewtask("");
              setselecteddate(new Date());
              setselectedemployee([]);
              setselectedproject("");
              setselectedtasktype("One Time");
              let employeesdata = [...employees];
              for (const key in employeesdata) {
                employeesdata[key].selected = false;
              }

              dispatch({
                type: actionType.STORE_EMPLOYEES,
                payload: employeesdata,
              });
            } else {
              toast.error(
                "Something went wrong while creating your reminder. Please try again later.",
              );
            }
            props.activateoutsidecontainerclick();
            props.refresh();

            setloader(false);
          })
          .catch((err) => {
            alert(err);
            setloader(false);
          });
      } else {
        toast.warn("Error creating reminder. Please try again later");
        setloader(false);
        console.log(res.error + "error message");
      }
    }
  }

  const Heading = (title) => {
    return <p className="pt-[10px] PoppinsRegular  text-textcolor ">{title}</p>;
  };

  return (
    props.visible && (
      <div className="position absolute z-10  top-[0] left-[0] w-full h-full bg-[rgba(211,211,211,0.4)] flex items-center justify-center ">
        <div
          ref={popupref}
          className="w-[80%] lg:w-[600px]   bg-themelightblack border border-bordercolor  rounded-xl  gk-scr  flex items-center justify-center flex-col    px-[20px]  max-h-[80%] lg:max-h-[100%] overflow-y-scroll"
        >
          <div className="flex w-full h-[100%] relative flex-col py-[20px]  overflow-scroll ">
            {/* {Heading("Create Task")} */}
            <div className="w-full mt-[10px] flex flex-col items-center ">
              {employees.filter((x) => x.selected).length > 0 ? (
                <div className="flex flex-row">
                  {employees
                    .filter((x) => x.selected)
                    .map((item, ind) => {
                      return (
                        <img
                          loading="lazy"
                          style={{
                            marginLeft:
                              employees.filter((x) => x.selected).length > 1
                                ? -50
                                : 0,
                          }}
                          src={
                            item.profilepicture ? item.profilepicture : userlogo
                          }
                          className="w-[100px] h-[100px] rounded-full object-cover"
                        />
                      );
                    })}
                </div>
              ) : (
                <div className="w-[100px] h-[100px] rounded-full  flex justify-center items-center bg-themelightblack bg-cardOverlay drop-shadow-lg ">
                  <FaUser className="w-[50px] h-[50px] text-themeColor" />
                </div>
              )}

              <div className="flex flex-col  justify-between   w-full">
                <div className="w-full  mt-5 md:mt-0 pb-1">
                  <div className="w-full relative">
                    <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                      Select Supervisor
                    </p>

                    <div
                      onClick={() => {
                        setemployeepopup(!employeepopup);
                      }}
                      className={`px-4 ${
                        selectedemployee?.length > 0
                          ? " text-lighttextGray "
                          : "text-textcolor"
                      } text-sm  PoppinsRegular w-full min-h-[45px] py-[10px] rounded-xl border border-bordercolor items-center flex flex-wrap`}
                    >
                      {employees?.length == 0 ||
                      employees.find((data) => data.selected == true) ==
                        undefined
                        ? "Select Supervisor"
                        : employees
                            .filter(function (data) {
                              return data.selected == true;
                            })
                            .map(function (data) {
                              return (
                                <div
                                  onClick={() => {
                                    let dataset = [...employees];
                                    const designationindex = dataset.findIndex(
                                      (item) => item.id === data.id,
                                    );
                                    dataset[designationindex].selected = false;
                                    dispatch({
                                      type: actionType.STORE_EMPLOYEES,
                                      payload: dataset,
                                    });
                                    setselectedemployee(
                                      dataset.filter((obj) => obj.selected),
                                    );
                                  }}
                                  className="bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                                >
                                  <p className="text-white ">
                                    {data.firstname}
                                  </p>
                                  <IoIosCloseCircle
                                    onClick={(id) => {
                                      console.log(id);
                                    }}
                                    className=" text-red-500 ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer"
                                  />
                                </div>
                              );
                            })}
                    </div>
                    <EmployeePopup
                      bulkaction={(status) => {
                        let currentemployees = [...employees];

                        let data = [...employees];
                        // Update the main 'employees' array to mark the selected ones
                        data.forEach((employee) => {
                          // Check if the employee is in the filtered 'currentemployees' array
                          const isSelected = currentemployees.some(
                            (selected) => selected.id === employee.id,
                          );

                          // Set a 'selected' property to true for the selected employees
                          employee.selected =
                            isSelected && employee.usertype == "Supervisor"
                              ? status
                              : false;
                        });

                        dispatch({
                          type: actionType.STORE_EMPLOYEES,
                          payload: data,
                        });
                        setselectedemployee(data.filter((obj) => obj.selected));
                      }}
                      multi={true}
                      style={{ top: "80px" }}
                      visible={employeepopup}
                      data={employees.filter(function (data) {
                        return data.usertype == "Supervisor";
                      })}
                      activateoutsidecontainerclick={() => {
                        setemployeepopup(false);
                      }}
                      onClick={(item, index) => {
                        let dataset = [...employees];
                        const designationindex = dataset.findIndex(
                          (data) => item.id === data.id,
                        );
                        dataset[designationindex].selected =
                          !dataset[designationindex].selected;
                        dispatch({
                          type: actionType.STORE_EMPLOYEES,
                          payload: dataset,
                        });
                        setselectedemployee(
                          dataset.filter((obj) => obj.selected),
                        );
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col  justify-between   w-full  mt-[10px] ">
                <div className="w-full  mt-5 md:mt-0 pb-1">
                  <div className="w-full relative">
                    <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                      Type
                    </p>
                    <div className="flex flex-row overflow-x-scroll bg-themelightblack py-[5px]">
                      {tasktypes.map(function (data) {
                        return (
                          <div
                            onClick={() => {
                              setselectedtasktype(data.type);
                            }}
                            className={`${
                              selectedtasktype == data.type
                                ? " bg-themeblue"
                                : "bg-themelightblack"
                            } bg-cardOverlay drop-shadow-md px-[10px] py-[5px] mx-[5px] rounded-full flex flex-row items-center hover:cursor-pointer`}
                          >
                            <p
                              className={`${
                                selectedtasktype == data.type
                                  ? " text-textcolor"
                                  : "text-textcolor"
                              }  text-[14px]`}
                            >
                              {data.type}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col  justify-between   w-full  mt-[10px] ">
                <div className="w-full  mt-5 md:mt-0 pb-1">
                  <div className="w-full relative">
                    <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                      Select Project
                    </p>

                    <div
                      onClick={() => {
                        setprojectpopup(!projectpopup);
                      }}
                      className={`px-4 ${
                        selectedproject != ""
                          ? " text-gray-500 "
                          : "text-textcolor"
                      } text-sm  PoppinsRegular w-full min-h-[45px] py-[10px] rounded-xl border border-bordercolor items-center flex flex-wrap`}
                    >
                      {selectedproject == "" ? (
                        "Select Project"
                      ) : (
                        <div
                          onClick={() => {
                            setselectedproject("");
                          }}
                          className="bg-themeColor px-[5px] py-[1px] mr-[5px] rounded-md flex flex-row items-center mb-[2px]"
                        >
                          <p className="text-white ">{selectedproject.title}</p>
                          <IoIosCloseCircle
                            onClick={(id) => {
                              console.log(id);
                            }}
                            className=" text-red-500 ml-[3px]  w-[15px] h-[15px] hover:cursor-pointer"
                          />
                        </div>
                      )}
                    </div>
                    <ProjectPopUp
                      style={{}}
                      visible={projectpopup}
                      data={clients}
                      activateoutsidecontainerclick={() => {
                        setprojectpopup(false);
                      }}
                      onClickcorrect={(item) => {
                        setselectedproject(item);

                        setprojectpopup(false);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col  mt-[10px]  w-full ">
                <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                  Date
                </p>
                <div className="w-full flex justify-between items-center">
                  <DatePicker
                    minDate={new Date()}
                    className="input PoppinsRegular  border border-bordercolor rounded-lg w-full bg-themelightblack text-white"
                    selected={selecteddate}
                    onChange={(date) => setselecteddate(date)}
                  />
                  <TimePicker
                    format="HH:mm"
                    className="  ml-[10px]  w-full h-[45px] bg-themelightblack text-white"
                    onChange={setremindertime}
                    value={remindertime}
                  />
                </div>
              </div>
            </div>
            <div className=" w-full mt-[10px] ">
              <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                Description
              </p>
              <textarea
                type="text"
                placeholder="Enter reminder details..."
                rows={1}
                value={newtask}
                onChange={(event) => {
                  console.log(event.target.value);
                  setnewtask(event.target.value);
                }}
                className={`input relative px-4 text-textcolor text-sm  PoppinsRegular w-full h-[90px] md:h-[125px] rounded-xl border border-bordercolor items-center flex bg-themelightblack`}
              />
            </div>
            {loader ? (
              <div className=" py-4  mt-6 w-full flex justify-center  ">
                <RotatingLines
                  visible={true}
                  height="25"
                  width="25"
                  color="grey"
                  strokeColor="#00C763"
                  strokeWidth="5"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              <button
                onClick={() => {
                  setupreminder();
                }}
                type="submit"
                className={`mt-[20px] text-center py-3 rounded-lg  bg-themeblue hover:bg-themeblue/80  text-white
                px-[10px]  text-sm  PoppinsRegular uppercase bg-cardOverlay  drop-shadow-lg`}
              >
                Create Task
              </button>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default Taskpopup;
